var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 17",
    width: 27,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 222") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #000000;stroke-miterlimit:100;stroke-width: 2.4 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 48",
    fillRule: "evenodd",
    className: "s0",
    d: "m2.1 2.6h22.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 49",
    fillRule: "evenodd",
    className: "s0",
    d: "m2.1 9h14.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 50",
    fillRule: "evenodd",
    className: "s0",
    d: "m2.1 14.6h7.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.0c3e8b89c029295d0ff81093a559ac29.svg";
export { ForwardRef as ReactComponent };